"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORTED_DIALECTS = exports.FUNCTION_DEFINITIONS = exports.FUNCTION_CATALOG = exports.extractColumnRefs = exports.parse = void 0;
exports.compile = compile;
exports.listFunctions = listFunctions;
const codegen_1 = require("./codegen");
const compiler_1 = require("./compiler");
const functions_1 = require("./functions");
var compiler_2 = require("./compiler");
Object.defineProperty(exports, "parse", { enumerable: true, get: function () { return compiler_2.parse; } });
var ast_1 = require("./ast");
Object.defineProperty(exports, "extractColumnRefs", { enumerable: true, get: function () { return ast_1.extractColumnRefs; } });
var functions_2 = require("./functions");
Object.defineProperty(exports, "FUNCTION_CATALOG", { enumerable: true, get: function () { return functions_2.FUNCTION_CATALOG; } });
Object.defineProperty(exports, "FUNCTION_DEFINITIONS", { enumerable: true, get: function () { return functions_2.FUNCTION_DEFINITIONS; } });
// Dialects the formula package can compile to. Consumers (backend mapper,
// frontend UI gating) use this as the single source of truth.
exports.SUPPORTED_DIALECTS = [
    'postgres',
    'redshift',
    'bigquery',
    'snowflake',
    'duckdb',
    'databricks',
    'clickhouse',
];
const supportedDialectsAreExhaustive = true;
void supportedDialectsAreExhaustive;
function compile(formula, options) {
    const ast = (0, compiler_1.parse)(formula);
    const generator = (0, codegen_1.createGenerator)(options);
    return generator.generate(ast);
}
function listFunctions() {
    return functions_1.FUNCTION_DEFINITIONS;
}
//# sourceMappingURL=index.js.map